import queryString from 'query-string';

export const getQueryParam = (key: string, search: string = window.location.search): string | null | undefined => {
  const parsed = queryString.parse(search);
  let match = parsed[key];
  if (Array.isArray(match)) {
    match = match[0];
  }

  return match;
};

export function isAmdCampaignRedirect(): boolean {
  // get the redirect_url from the page URL and check if it contains /amd/campaigns/
  try {
    const url = window.location.href;

    const searchParamString = url;
    const searchParams = new URL(searchParamString);
    const redirectUrl = searchParams.searchParams.get('redirect_url');
    if (redirectUrl) {
      let urlObj: URL;
      try {
        urlObj = new URL(redirectUrl);
      } catch (e) {
        return false;
      }
      return urlObj.pathname.includes('/amd/campaigns/');
    }
  } catch (e) {
    return false;
  }
  return false;
}
